import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));

function TestimonialsSection(props) {
  const classes = useStyles();
  const items = [
    {
      name: "Customizable",
      testimonial:
        "~350 billion emails are sent every day. We won't box you in.",
      avatar: "https://uxwing.com/wp-content/themes/uxwing/download/signs-and-symbols/finger-print-icon.png",
    },
    {
      name: "One to Many Recipients",
      testimonial:
        "Want a unique newsletter for your unique interests? Want to motivate your team? Building an audience you want an interactive platform for?",
      avatar: "https://uxwing.com/wp-content/themes/uxwing/download/business-professional-services/team-icon.png",
    },
    {
      name: "One-Tap Surveys",
      testimonial:
        "Want to keep yourself accountable to daily goals? Want a low-friction way to check-in with your team? Want your audience to give feedback to your content?",
      avatar: "https://uxwing.com/wp-content/themes/uxwing/download/business-professional-services/column-chart-icon.png",
    },
    {
      name: "Schedulable",
      testimonial:
        "Options for daily, weekly, monthly delivery to check in with yourself, your team, or your audience at any frequency.",
      avatar: "https://uxwing.com/wp-content/themes/uxwing/download/time-and-date/calendar-line-icon.png",
    },
  ];
  // const items = [
  //   {
  //     avatar: "https://uploads.divjoy.com/pravatar-150x-5.jpeg",
  //     name: "Sarah Kline",
  //     testimonial:
  //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.",
  //     company: "Company",
  //   },
  //   {
  //     avatar: "https://uploads.divjoy.com/pravatar-150x-48.jpeg",
  //     name: "Shawna Murray",
  //     testimonial:
  //       "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam!",
  //     company: "Company",
  //   },
  //   {
  //     avatar: "https://uploads.divjoy.com/pravatar-150x-12.jpeg",
  //     name: "Blake Elder",
  //     testimonial:
  //       "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae.",
  //     company: "Company",
  //   },
  // ];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        <Grid container={true} justifyContent="center" spacing={4}>
          {items.map((item, index) => (
            <Grid item={true} xs={12} md={3} key={index}>
              <Card>
                <Box display="flex" justifyContent="center" pt={3}>
                  <Avatar
                    src={item.avatar}
                    alt={item.name}
                    className={classes.avatar}
                  />
                </Box>
                <CardContent>
                  <Box textAlign="center">
                    <Box mt={3}>
                      <Typography variant="body1" component="p">
                        <strong>{item.name}</strong>
                      </Typography>
                    </Box>
                    <Typography variant="body1" component="p">
                      {item.testimonial}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}

export default TestimonialsSection;
